module.exports = __webpack_public_path__ + "static/media/img4.e1a4b043.jpg";